/*
 *  Copyright (c) Qwoach LLC 2023. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 15/9/2023
 */

import CommonObject from "@shared/CommonObject.js";

// import Cookie from "@/core/js/Cookie/Cookie.js";
import analyticManager from "@/entry/setupAnalytic.js";
import dataManager from "@/entry/setupDataManager";

// let cookie = new Cookie()

// CommonObject.cookie = cookie
CommonObject.analyticManager = analyticManager
CommonObject.dataManager = dataManager
// export {
// 	cookie
// }
